<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("invoicesAnalysis/getDetails", this.itemId);
    },
    computed: {
        invoice() {
            return this.$store.state.invoicesAnalysis.invoice;
        }
    },
    data() {
        return {
            headersService: [
                { text: 'اسم التحليل', value: 'serviceName' },
                { text: 'السعر ', value: 'price' },
            ], 
          
        };
    },
};
</script>